import { createContext } from 'react';

import type { CardProps } from './Card.types';

export type CardContextProps = Pick<CardProps, 'height'>;

export const CardContext = createContext<CardContextProps>({} as CardContextProps);
